import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://inkword-backend.onrender.com/api',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true,
  timeout: 10000, // 10 seconds timeout
});

// Add request interceptor for error handling
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  response => response,
  error => {
    if (error.code === 'ERR_NETWORK') {
      console.error('Network error - Please check if the backend server is running');
    }
    return Promise.reject(error);
  }
);

const logApiCall = async (name, fn) => {
  try {
    console.log(`API Call: ${name} - Started`);
    const result = await fn();
    console.log(`API Call: ${name} - Successful`, result.data);
    return result;
  } catch (error) {
    console.error(`API Call: ${name} - Failed`, error);
    throw error;
  }
};

const apiEndpoints = {
  auth: {
    login: (credentials) => logApiCall('auth.login', () => api.post('/auth/login', credentials)),
    register: (userData) => logApiCall('auth.register', () => api.post('/auth/register', userData)),
    verifyOTP: (data) => logApiCall('auth.verifyOTP', () => api.post('/auth/verify-otp', data)),
    sendOTP: (email) => logApiCall('auth.sendOTP', () => api.post('/auth/send-otp', { email })),
  },
  posts: {
    getAll: (params) => logApiCall('posts.getAll', () => api.get('/posts', { params })),
    getById: (id) => logApiCall('posts.getById', () => api.get(`/posts/${id}`)),
    create: (postData) => logApiCall('posts.create', () => api.post('/posts', postData)),
    update: (id, postData) => logApiCall('posts.update', () => api.put(`/posts/${id}`, postData)),
    delete: (id) => logApiCall('posts.delete', () => api.delete(`/posts/${id}`)),
    search: (params) => logApiCall('posts.search', () => api.get('/posts/search', { params })),
  },
  // Add other API endpoints as needed
};

export { api, apiEndpoints }; 
